function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.112.5H.5v16h10.612V.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.152 11.526V16.5h3.26v-4.974h-3.26zM12.636 16.5c-.11 0-.091-.012-.052-.05.101-.101.235-.259.394-.467.288-.377.642-.895 1.093-1.588l.18-.275.817-1.277c.3-.47.497-.768.652-.99.508-.724.78-1.508.78-2.328a3.864 3.864 0 1 0-7.259 1.846c.574 1.053.93 1.689 1.393 2.456.2.331.392.64.577.922.699 1.069 1.306 1.751 1.425 1.751z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.484,
  cy: 9.6,
  r: 1.132
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M2.387 2.843h2.876M2.387 4.818h2.876M2.387 6.762h2.876M2.387 8.737h2.876"
}));

var SvgDepartments = function SvgDepartments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDepartments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/departments.054a5abd.svg";
export { ForwardRef as ReactComponent };